import { render, staticRenderFns } from "./childTaskDetailDlg.vue?vue&type=template&id=3c627bf4&scoped=true"
import script from "./childTaskDetailDlg.vue?vue&type=script&lang=js"
export * from "./childTaskDetailDlg.vue?vue&type=script&lang=js"
import style0 from "./childTaskDetailDlg.vue?vue&type=style&index=0&id=3c627bf4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c627bf4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c627bf4')) {
      api.createRecord('3c627bf4', component.options)
    } else {
      api.reload('3c627bf4', component.options)
    }
    module.hot.accept("./childTaskDetailDlg.vue?vue&type=template&id=3c627bf4&scoped=true", function () {
      api.rerender('3c627bf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/compliance/task/dialog/childTaskDetailDlg.vue"
export default component.exports